export default "__VITE_ASSET__CBCaVyoD__"